
const $dateFormat = function(data){
  var date
  if (typeof (data) == 'string') {
    date = new Date(data.replace(/-/g, "/"))
  } else {
    date = new Date(data)
  }
  if (date == null || isNaN(Date.parse(new Date(date))) || data === 0) {
    return '--'
  }
  var month = date.getMonth() + 1 < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1
  var day = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
  var hour = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
  var min = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
  var s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
  return date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + min + ":" + s
}
const $dateFormatShort = function(data){
  var date
  if (typeof (data) == 'string') {
    date = new Date(data.replace(/-/g, "/"))
  } else {
    date = new Date(data)
  }
  if (date == null || isNaN(Date.parse(new Date(date))) || data === 0) {
    return '--'
  }
  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1
  var day = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
  return year + "-" + month + "-" + day
}
const $saveAuthInfo = function(response) {
  window.localStorage.setItem('token', response.data.token)
  if (response.data.open_id) {
    window.localStorage.setItem('openId', response.data.open_id)
  }
  window.localStorage.setItem('mobile', response.data.mobile)
  // $setCookie('token', response.data.token, 365)
}
const $setCookie = function(name, value, day){
  let date = new Date()
  date.setTime(date.getTime() + (day * 24 * 60 * 60 * 1000))
  document.cookie = name + "=" + value + ";expires=" + date.toGMTString()
}
const $getQueryString = function(name) { // 获取网址key对应的value
  var reg = new RegExp('(^|&|)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.href.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}
const $setLocalStorage = function(key, value) {
  window.localStorage.setItem(key, value)
}
const $getLocalStorage = function(key) {
  return window.localStorage.getItem(key)
}
const $removeLocalStorage = function(key) {
  window.localStorage.removeItem(key)
}
const $removeAllLocalStorage = function() {
  window.localStorage.removeItem('token')
  window.localStorage.removeItem('openId')
  window.localStorage.removeItem('prepayOrderId')
}
const $pushStateEvent = function() {
  window.history.pushState(null, null, location.href)
}

export default {
  $dateFormat,
  $dateFormatShort,
  $saveAuthInfo,
  $setCookie,
  $getQueryString,
  $setLocalStorage,
  $getLocalStorage,
  $removeLocalStorage,
  $removeAllLocalStorage,
  $pushStateEvent
}



// WEBPACK FOOTER //
// ./src/utils/functions/index.js